import { BIND_TYPE } from '@constants'

import { GANTT_BIND_TYPE_LIST, GanttColumnForm } from '@gantt/components/GanttCreateOrEdit'

export const getGanttColumnDefaultValue = (code: number): GanttColumnForm => {
  return {
    id: Date.now(),
    title: '',
    code: `column_${code}`,
    field: {
      bindType: GANTT_BIND_TYPE_LIST.FIELD,
      field: { field: '', pathStr: '', pathArray: [] },
    },
    valueType: null,
    jsValue: '',
    bindType: { id: BIND_TYPE.FIELD, label: BIND_TYPE.FIELD },
    fields: [{ bindType: GANTT_BIND_TYPE_LIST.FIELD, field: undefined }],
    pinning: false,
    pinnedColumn: null,
    useParameters: false,
    visibility: true,
    parameters: [],
  }
}
